<template>
  <div class="array-question">
    <h4
      :class="[
        body.header ? 'mb-3' : '',
        heading ? 'question-title h2' : 'label-text',
      ]"
    >
      {{ body.question }}
    </h4>
    <p class="sub-text">
      {{ body.header }}
    </p>
    <div :class="{'tw-overflow-hidden tw-rounded-xl tw-h-[150px]': isOnboardingRedesign}">
      <b-form-tags
        v-model="answer"
        input-id="tags-basic"
        class="text-tag mb-3 tw-overflow-y-auto"
        :class="{ 'fs-mask': isSensitive, 'redesign-tag tw-text-lg': isOnboardingRedesign, 'non-hrt': ['H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingPatient?.flow_variant) }"
        tag-variant="primary"
        add-button-variant="link"
        add-button-text="+ Add"
        separator=","
        :placeholder="placeholder"
        :disabled="disabled"
        @focus.native="focus"
      />
    </div>

    <OnboardingCTAContainer>
      <b-button
        pill
        block
        variant="info"
        :disabled="disabled"
        class="slight-rounded"
        :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
        @click="checkAnswer"
      >
        Continue
      </b-button>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';

export default {
  components: {
    OnboardingCTAContainer,
  },
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    othersField: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholder: 'Enter here...',
      answer: [],
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    isSensitive() {
      return this.body.hasOwnProperty('sensitive') && this.body.sensitive;
    },
  },
  watch: {
    body: {
      handler() {
        if (this.body.hasOwnProperty('answer')) {
          this.answer = this.body.answer;
        } else if (this.othersField.length > 0) {
          this.answer = this.othersField;
        } else {
          this.answer = [];
        }

        if (this.body.hasOwnProperty('placeholder')) {
          this.placeholder = this.body.placeholder || this.placeholder;
        }
      },
      immediate: true,

    },
    isOnboardingRedesign: {
      handler(val) {
        this.placeholder = val ? 'Type here...' : 'Enter here...';
      },
      immediate: true,
    },
  },
  methods: {
    focus() {
      event.target.querySelector('#tags-basic').focus();
    },
    checkAnswer() {
      if (
        this.answer.length == 0 &&
        (!this.body.hasOwnProperty('allowempty') || !this.body.allowempty)
      ) {
        this.$emit('alert', 'Please fill in all fields.');
      } else {
        this.$emit('submitAnswer', this.body.id, this.answer, this.body);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .b-form-tags-button {
  min-width: 75px !important;
  width: 75px;
}

::v-deep .b-form-tag-content {
  font-size: 1.35em;
}

::v-deep .redesign-tag .b-form-tag-content {
  text-overflow: unset;
  white-space: normal !important;
}

::v-deep .redesign-tag .badge.b-form-tag {
  word-break: break-all !important;
  text-align: left !important;
}

::v-deep .b-form-tags.non-hrt {
  position: relative;
}

::v-deep .b-form-tags.non-hrt .b-form-tags-button {
  background-color: white;
  position: absolute;
  right: 0;
  top: 5px;
  padding: 0;
}
</style>

<style lang="scss" scoped>
.text-tag {
  background-color: #f8f8f8;

  &:focus {
    background-color: #f8f8f8;
  }
}

.redesign {
  .text-tag {
    background-color: #ffffff;
    border: 1px solid #C7C7C7;
    border-radius: 0.75rem;
    padding: 0.875rem !important;

    &:focus {
      background-color: #ffffff;
    }
    ::v-deep .b-form-tags-button{
      text-transform: capitalize;
      letter-spacing: normal;
      text-decoration: underline;
      text-underline-offset: 4px;
      white-space: nowrap;
      color: $primary;
      font-weight: normal;

      font-size: 110% !important;
    }
  }

}

.heading {
  font-weight: normal !important;
}
</style>
